import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import LocizeBackend from 'i18next-locize-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import LocizeLastUsed from 'locize-lastused';

var regexp = new RegExp('\{\{(.+?)\}\}', 'g');

function makeString(object) {
  if (object == null) return '';
  return '' + object;
}

function interpolate(str, data, lng) {
  var match, value;

  function regexSafe(val) {
    return val.replace(/\$/g, '$$$$');
  } // regular escape on demand


  while (match = regexp.exec(str)) {
    value = match[1].trim();
    if (typeof value !== 'string') value = makeString(value);
    if (!value) value = '';
    value = regexSafe(value);
    str = str.replace(match[0], data[value] || value);
    regexp.lastIndex = 0;
  }

  return str;
}

function formatLanguageCode(code) {
  return code;
}
function getLanguagePartFromCode(code) {
  if (code.indexOf('-') < 0) return code;
  var specialCases = ['NB-NO', 'NN-NO', 'nb-NO', 'nn-NO', 'nb-no', 'nn-no'];
  var p = code.split('-');
  return specialCases.indexOf(code) > -1 ? p[1].toLowerCase() : p[0];
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var services = {
  interpolator: {
    interpolate: interpolate
  },
  languageUtils: {
    formatLanguageCode: formatLanguageCode
  }
};

var asyncEach = function asyncEach(arr, fn, callback) {
  var results = [];
  var count = arr.length;
  arr.forEach(function (item, index) {
    fn(item, function (err, data) {
      results[index] = data;

      if (err) {
        callback && callback(err);
        callback = null;
      }

      if (--count === 0 && callback) {
        callback(null, results);
      }
    });
  });
};

var locizer = {
  init: function init(options) {
    this.options = options;
    this.backend = new LocizeBackend(services, options);
    this.detector = new LanguageDetector(services, options);
    this.lng = options.lng || this.detector.detect();
    this.referenceLng = options.referenceLng;
    LocizeLastUsed.init(options);
    return this;
  },
  isValid: function isValid(lngs, l) {
    return lngs[l] && lngs[l].translated[this.options.version || 'latest'] >= (this.options.loadIfTranslatedOver || 1);
  },
  getLanguage: function getLanguage(lng, callback) {
    var _this = this;

    if (typeof lng === 'function') {
      callback = lng;
      lng = this.lng;
    }

    if (!lng) lng = this.lng;
    this.getLanguages(function (err, lngs) {
      if (err) return callback(err);
      if (_this.isValid(lngs, lng)) return callback(null, lng);
      if (_this.isValid(lngs, getLanguagePartFromCode(lng))) return callback(null, getLanguagePartFromCode(lng));
      callback(null, _this.options.fallbackLng || _this.referenceLng || Object.keys(lngs)[0]);
    });
    return this;
  },
  getLanguages: function getLanguages(callback) {
    var _this2 = this;

    if (this.publishedLngs) {
      callback(null, this.publishedLngs);
    } else {
      this.backend.getLanguages(function (err, data) {
        if (err) return callback(err);
        if (!err) _this2.publishedLngs = data;

        if (!_this2.referenceLng) {
          Object.keys(data).forEach(function (l) {
            if (data[l].isReferenceLanguage) _this2.referenceLng = l;
          });
        }

        callback(null, data);
      });
    }

    return this;
  },
  load: function load(ns, lng, callback) {
    var _this3 = this;

    if (typeof lng === 'function') {
      callback = lng;
      lng = null;
    }

    this.getLanguage(lng, function (err, lng) {
      if (err) return callback(err);

      _this3.backend.read(lng, ns, function (err, data) {
        return callback(err, data, lng);
      });
    });
    return this;
  },
  loadAll: function loadAll(ns, callback) {
    var _this4 = this;

    this.getLanguages(function (err, lngs) {
      if (err) return callback(err);
      var validLngs = Object.keys(lngs).filter(function (l) {
        return _this4.isValid(lngs, l);
      });
      asyncEach(validLngs, function (l, clb) {
        _this4.load(ns, l, function (err, res) {
          if (err) return clb(err);
          clb(null, _defineProperty({}, l, res));
        });
      }, function (err, results) {
        if (err) return callback(err);
        var ret = results.reduce(function (prev, l) {
          return _objectSpread(_objectSpread({}, prev), l);
        }, {});
        callback(null, ret);
      });
    });
    return this;
  },
  add: function add(namespace, key, value, context, callback) {
    var options = {};

    if (typeof context === 'function') {
      callback = context;
    } else if (typeof context === 'string') {
      options.tDescription = context;
    }

    this.backend.create(this.referenceLng, namespace, key, value, callback, options);
    return this;
  },
  update: function update(namespace, key, value, context, callback) {
    var options = {
      isUpdate: true
    };

    if (typeof context === 'function') {
      callback = context;
    } else if (typeof context === 'string') {
      options.tDescription = context;
    }

    this.backend.create(this.referenceLng, namespace, key, value, callback, options);
    return this;
  },
  used: function used(namespace, key) {
    LocizeLastUsed.used(namespace, key);
  }
};

export default locizer;
